module.exports = __webpack_public_path__ + "static/security5@2x-f0a51e01247f4c75f4a3da429297011d.png";